import { z } from "zod";
import type { PublicError } from "./http";

const PUBLIC_MESSAGES = {
  invalid_request: "Revise os dados enviados e tente novamente.",
  unauthorized: "Sua sessão não é válida.",
  forbidden: "Este recurso não está disponível.",
  not_found: "O recurso solicitado não foi encontrado.",
  internal_error: "Não foi possível concluir a operação.",
} as const;

export class ContractValidationError extends Error {
  public readonly issues: readonly z.core.$ZodIssue[];

  public constructor(error: z.ZodError) {
    super(PUBLIC_MESSAGES.invalid_request);
    this.name = "ContractValidationError";
    this.issues = error.issues;
  }
}

function invalidRequest(
  issues: readonly z.core.$ZodIssue[],
  requestId: string | null,
): PublicError {
  return {
    code: "invalid_request",
    message: PUBLIC_MESSAGES.invalid_request,
    request_id: requestId,
    details: issues.slice(0, 20).map((issue) => ({
      code: issue.code,
      path: issue.path.filter(
        (segment): segment is string | number =>
          typeof segment === "string" || typeof segment === "number",
      ),
    })),
  };
}

export function toPublicError(error: unknown, requestId: string | null = null): PublicError {
  if (error instanceof z.ZodError) return invalidRequest(error.issues, requestId);
  if (error instanceof ContractValidationError) return invalidRequest(error.issues, requestId);
  return {
    code: "internal_error",
    message: PUBLIC_MESSAGES.internal_error,
    request_id: requestId,
  };
}

export function parseExternal<T>(schema: z.ZodType<T>, value: unknown): T {
  const result = schema.safeParse(value);
  if (!result.success) throw new ContractValidationError(result.error);
  return result.data;
}
